/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebphasecreating3Inputs */

const en_placewebphasecreating3 = /** @type {(inputs: Placewebphasecreating3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating the place`)
};

const de_placewebphasecreating3 = /** @type {(inputs: Placewebphasecreating3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort wird angelegt`)
};

/**
* | output |
* | --- |
* | "Creating the place" |
*
* @param {Placewebphasecreating3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebphasecreating3 = /** @type {((inputs?: Placewebphasecreating3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebphasecreating3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebphasecreating3(inputs)
	return de_placewebphasecreating3(inputs)
});
export { placewebphasecreating3 as "placeWebPhaseCreating" }